export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./boldplay.vue?vue&type=template&id=2d4d4bff&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/boldplay.vue?vue&type=template&id=2d4d4bff&scoped=true
// module id = vk6Z
// module chunks = 0